module.exports = __webpack_public_path__ + "static/media/SOBREAEMPRESA.4138d28d.png";